import React, { useEffect, useRef, useState } from "react";
import Header from "../common/header/Header";
import axios from "axios";
import { ENDPOINTS } from "../../js/api/_config";
import DataTable from "react-data-table-component";
import PrimaryButton from "../common/buttons/PrimaryButton";
import { Link, useNavigate } from "react-router";

import { FaEdit } from "react-icons/fa";
import { Toast } from "../common/toast/toast";
import ColorCount from "./color-count";
import { useDispatch, useSelector } from "react-redux";
import SecondaryButton from "../common/buttons/SecondaryButton";

import { IconViewDetailHovered } from "../../assets/icons/icon-view-detail-hover";
import { IconViewDetail } from "../../assets/icons/icon-details";
import { IconEditHovered } from "../../assets/icons/icon-edit-hover";
import { IconEdit } from "../../assets/icons/icon-edit";
import { IconMoveTrial } from "../../assets/icons/icon-move-trial";
import { IconMoveTrialHover } from "../../assets/icons/icon-move-trial-hover";
import { isAction } from "@reduxjs/toolkit";
import { getTrailsName } from "../../reducer/slices/trial/get-trial-name-slice";
import useMediaQuery from "../common/custom-hooks/use-media-query";
const Trials = () => {
  const [getTrials, setGetTrials] = useState([]);
  const [mainActiveTrials, setMainActiveTrials] = useState([]);
  const [showClose, setShowClose] = useState(false);
  const [activeTrials, setActiveTrials] = useState([]);
  const [search, setSearch] = useState("");
  const [completedTrials, setCompletedTrials] = useState([]);
  const [activeTab, setActiveTab] = useState("active");
  const [loading, setLoading] = useState(true);

  const [toasts, setToasts] = useState([]);
  const trailData = useSelector((state) => state.trails_name.data);
  const trialIsLoading = useSelector((state) => state.trails.isLoading);
  const clinicData = useSelector((state) => state.clinic_info.data);

  const [clinicalInfoIds, setClinicalInfoIds] = useState([]);

  const [dropDown, setDropDown] = useState(false);
  const [locationDropDown, setLocationDropDown] = useState(false);
  const [hover, setHover] = useState(false);
  const [hover2, setHover2] = useState(false);
  const [deleteTooltip, setDeleteTooltip] = useState();
  const [viewTooltip, setViewTooltip] = useState();
  const [isDelete, setIsDelete] = useState(false);
  const [isViewHovered, setIsViewHovered] = useState(false);
  const [isEditHovered, setIsEditHovered] = useState(false);
  const [isTrailInfo, setIsTrailInfo] = useState("");
  const dispatch = useDispatch();
  const dropdownRef = useRef(null);
  const locationDropdownRef = useRef(null);
  const isBigDesktop = useMediaQuery("(min-width: 1440px)");
  const truncate = (text, limit) => {
    return text.length > limit ? text.substring(0, limit) + "..." : text;
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropDown(false);
      }

      if (
        locationDropdownRef.current &&
        !locationDropdownRef.current.contains(event.target)
      ) {
        setLocationDropDown(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const handleSelectChange = (value) => {
    const selectedTrialID = value;
    if (selectedTrialID) {
      navigate(`/trial/${selectedTrialID}`);
    }
  };

  const handleLocationChange = (value) => {
    setClinicalInfoIds((prev) =>
      prev.includes(value) ? prev.filter((x) => x !== value) : [...prev, value],
    );
  };

  const handleToggleSelectAll = () => {
    const allIds = clinicData.map((item) => item.clinicalInfoID);

    setClinicalInfoIds((prev) => (prev.length === allIds.length ? [] : allIds));
  };

  const addToast = (message, type) => {
    const id = Date.now();
    setToasts([...toasts, { id, message, type }]);
    setTimeout(() => removeToast(id), 3000);
  };

  const removeToast = (id) => {
    setToasts(toasts.filter((toast) => toast.id !== id));
  };

  const onSearchClick = () => {
    if (!search) {
      return;
    }

    const lowerCaseSearchTerm = search.toLowerCase();

    const searchedValue = mainActiveTrials.filter((item) => {
      return item.trialName.toLowerCase().includes(lowerCaseSearchTerm);
    });

    setActiveTrials(searchedValue);
    setShowClose(true);
  };

  const onCloseClick = () => {
    setActiveTrials([...mainActiveTrials]);
    setSearch("");
    setShowClose(false);
  };

  const customStyles = {
    table: {
      style: {
        // border: '1px solid #C8D6E6', // Border around the entire table
        borderRadius: "6px", // Rounded corners for the table
        overflow: "hidden",
        borderLeft: "1px solid #E0E7F0",
        borderTop: "1px solid #E0E7F0",
        borderRight: "1px solid #E0E7F0",
        borderBottom: "1px solid #E0E7F0",
        // Prevent content overflow if border is rounded
      },
    },
    headCells: {
      style: {
        backgroundColor: "#EAEDF2", // Green background for the header
        color: "#1B2A3D", // White text color
        fontWeight: "600", // Bold text
        fontSize: "16px", // Font size
        padding: "14px 20px",
        borderRight: "1px solid #C8D6E6",
        fontFamily: "Montserrat",
        fontSize: "16px",
        //height:'48px',
        // Padding around the header cells
      },
    },

    cells: {
      style: {
        fontSize: "14px", // Font size for table cells
        padding: "20px", // Padding around cells
        fontWeight: 600,
        height: "66px",
        fontFamily: "Montserrat",
        color: "#373737",
      },
    },
  };

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await axios.get(ENDPOINTS.TRIALS.GET_ALL_TRIAL, {
        params: {
          clinicalInfoIds: clinicalInfoIds.join(","),
        },
      });

      setGetTrials(response.data.data);

      const Active = response.data.data.filter((t) => t.isActive);
      const Completed = response.data.data.filter((t) => !t.isActive);
      setActiveTrials(Active);
      setMainActiveTrials(Active);
      setCompletedTrials(Completed);
    } catch (error) {
      console.error("Error fetching recruiters:", error);
    } finally {
      setLoading(false); // Set loading to false after the API call
    }
  };

  // useEffect(() => {
  //   if (clinicData && clinicData.length > 0) {
  //     setClinicalInfoIds([clinicData[0].clinicalInfoID]);
  //   }
  // }, [clinicData]);

  useEffect(() => {
    if (clinicalInfoIds) {
      fetchData();
    }
  }, [clinicalInfoIds]);

  async function activeAndDeactiveTrials(trialId, isActive) {
    const url = isActive
      ? `${ENDPOINTS.TRIALS.DEACTIVE}${trialId}`
      : `${ENDPOINTS.TRIALS.ACTIVE}${trialId}`; // Include trialID in the URL
    try {
      const response = await axios.put(url);
      addToast(
        `Trial moved successfully to ${isActive ? "Inactive" : "Active"}`,
        "success",
      );
      dispatch(getTrailsName({}));
      fetchData();
      return response.data;
    } catch (error) {
      if (error.response) {
        // Handle server-side errors (4xx, 5xx)
        addToast(error.response.data.message, "error");
        console.error("API Error:", error.response.data);
        throw new Error(
          `Failed to delete trial: ${
            error.response.data.message || error.response.status
          }`,
        );
      } else if (error.request) {
        // Handle no response from server
        console.error("No response received:", error.request);
        throw new Error(
          "No response from the server. Please check your network.",
        );
      } else {
        // Handle unexpected errors
        console.error("Error:", error.message);
        throw new Error(error.message);
      }
    }
  }

  async function inactiveTrials(row) {
    const fData = mainActiveTrials.filter(
      (data) => data.trialID === row.trialID,
    );

    try {
      const result = await activeAndDeactiveTrials(row.trialID, row.isActive);
      setIsDelete(false);
    } catch (error) {
      addToast("Failed to remove patient:", "error");

      console.error("Failed to remove patient:", error);
    }
  }

  const activeTrialColumnList = [
    {
      name: "Trial Name",
      selector: (row) => (
        <div className="flex">
          <span
            onClick={() => handleRowClick(row.trialID, row)}
            className="cursor-pointer text-[14px] font-medium text-[#245CEA] hover:font-semibold hover:underline"
          >
            {row.trialName}
          </span>
          <div
            className="ml-3"
            onMouseEnter={() => setIsTrailInfo(row.trialID)}
            onMouseLeave={() => setIsTrailInfo()}
          >
            {" "}
            <div className="">
              {row.trialInformation && (
                <div className="relative">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      d="M10.0003 9.16602V14.166M18.3337 9.99935C18.3337 14.6017 14.6027 18.3327 10.0003 18.3327C5.39795 18.3327 1.66699 14.6017 1.66699 9.99935C1.66699 5.39698 5.39795 1.66602 10.0003 1.66602C14.6027 1.66602 18.3337 5.39698 18.3337 9.99935Z"
                      stroke="#1A1A1B"
                      strokeWidth="1.2"
                      strokeLinecap="round"
                    />
                    <path
                      d="M10.8337 6.66536C10.8337 7.1256 10.4606 7.4987 10.0003 7.4987C9.54009 7.4987 9.16699 7.1256 9.16699 6.66536C9.16699 6.20513 9.54009 5.83203 10.0003 5.83203C10.4606 5.83203 10.8337 6.20513 10.8337 6.66536Z"
                      fill="#1A1A1B"
                    />
                  </svg>
                </div>
              )}{" "}
              {isTrailInfo === row.trialID && (
                <div
                  className={`absolute ${
                    isBigDesktop ? "" : "right-[0px]"
                  } top-[-20px] bg-white border border-[#EEF2FE] shadow-lg z-50 overflow-hidden p-3 text-[10px] w-[30vw] text-wrap max-h-20 overflow-y-auto`}
                >
                  {truncate(row.trialInformation, 250)}
                </div>
              )}
            </div>
          </div>
        </div>
      ),
    },
    {
      name: "In Progress",
      selector: (row) => (
        <ColorCount color={"#6F6EDE"} count={row.totalInProgress} />
      ),
      width: "160px",
    },
    {
      name: "Booked",
      selector: (row) => (
        <ColorCount color={"#15B392"} count={row.totalBooked} />
      ),
      width: "160px",
    },
    {
      name: "Scheduled Screen",
      selector: (row) => (
        <ColorCount color={"#AA5486"} count={row.totalScheduledScreen} />
      ),
      width: "200px",
    },
    {
      name: "Action Required",
      selector: (row) => (
        <ColorCount color={"#F26666"} count={row.totalActionRequired} />
      ),
      width: "200px",
    },
    {
      name: "Total Count",
      selector: (row) => <ColorCount color={"#536493"} count={row.total} />,
      width: "160px",
    },
    {
      name: "",
      selector: (row) => (
        <div>
          <div className="relative">
            {/* <button onClick={() => handleRowClick(row.trialID, row)} onMouseEnter={() => { setViewTooltip(row.trialID) }} onMouseLeave={() => setViewTooltip('')} ><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                            <path d="M1.375 11.125C1.375 11.125 4.875 4.125 11 4.125C17.125 4.125 20.625 11.125 20.625 11.125C20.625 11.125 17.125 18.125 11 18.125C4.875 18.125 1.375 11.125 1.375 11.125Z" stroke="#1A1A1B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M11 13.75C12.4497 13.75 13.625 12.5747 13.625 11.125C13.625 9.67525 12.4497 8.5 11 8.5C9.55025 8.5 8.375 9.67525 8.375 11.125C8.375 12.5747 9.55025 13.75 11 13.75Z" stroke="#1A1A1B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg></button> */}
            <button
              onClick={() => handleRowClick(row.trialID, row)}
              // title="View"
              className="px-[20px]"
              onMouseEnter={() => {
                setIsViewHovered(row.trialID);
                setViewTooltip(row.trialID);
              }}
              onMouseLeave={() => {
                setIsViewHovered(null);
                setViewTooltip("");
              }}
            >
              {isViewHovered === row.trialID ? (
                <IconViewDetailHovered />
              ) : (
                <IconViewDetail />
              )}
            </button>
            <button
              onClick={() => setIsDelete(row)}
              // title="Edit"
              onMouseEnter={() => {
                setIsEditHovered(row.id);
                setDeleteTooltip(row.trialID);
              }}
              onMouseLeave={() => {
                setIsEditHovered(null);
                setDeleteTooltip("");
              }}
            >
              {isEditHovered === row.id ? (
                <IconMoveTrialHover />
              ) : (
                <IconMoveTrial />
              )}
            </button>
          </div>
          {deleteTooltip === row.trialID && (
            <div className="absolute left-[-20px] -top-[10px]  bg-white border border-[#C8D6E6] rounded-md shadow-lg z-30 overflow-hidden p-2 text-[10px]">
              {row.isActive ? "Move to Inactive" : "Move to Active"}
            </div>
          )}
        </div>
      ),
      width: "150px",
    },
  ];
  const activeTtrialColumnData = activeTrials.map((t) => {
    return {
      trialID: t.trialID,
      trialName: t.trialName,
      totalInProgress: t.totalInProgress,
      totalScheduledScreen: t.totalScheduledScreen,
      totalBooked: t.totalBooked,
      trialInformation: t.trialInformation,
      totalActionRequired: t.totalActionRequired,
      total: t.total,
      isActive: t.isActive,
    };
  });

  const completedTtrialColumnData = completedTrials.map((t) => {
    return {
      trialID: t.trialID,
      trialName: t.trialName,
      totalInProgress: t.totalInProgress,
      totalScheduledScreen: t.totalScheduledScreen,
      totalBooked: t.totalBooked,
      trialInformation: t.trialInformation,
      totalActionRequired: t.totalActionRequired,
      total: t.total,
      isActive: t.isActive,
    };
  });

  const navigate = useNavigate();

  const handleRowClick = (id, trialData) => {
    const key = "all";
    navigate(
      `/trial-statuses/${key}?trial_id=${id}&&sorting=desc&&trial_name=${
        trialData && trialData.trialName
      }`,
      { state: { id, trialData } },
    );
  };

  return (
    <>
      <Header
        headertitle="Trials"
        showClose={showClose}
        isSearch={true}
        search={search}
        setSearch={setSearch}
        onSearchClick={onSearchClick}
        onCloseClick={onCloseClick}
      />
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          toast={toast}
          onClose={() => removeToast(toast.id)}
        />
      ))}
      <div className="main-body px-8 py-4 border-b table_border">
        <div className="flex justify-between">
          <div className="flex">
            <button
              onClick={() => {
                navigate("/create-trial");
              }}
              onMouseEnter={() => {
                setHover(true);
              }}
              onMouseLeave={() => setHover(false)}
              className="flex items-center bg-[#245CEA] text-white py-2 px-5 rounded-[5px] hover:bg-white border hover:border-[#245CEA] hover:text-[#1A1A1B] transition duration-300 h-[42px] text-[16px] font-mont font-[600]"
            >
              <span className="text-xl font-bold mr-[10px]">
                {hover ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                  >
                    <path
                      d="M9 1V17"
                      stroke="#1A1A1B"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M1 9H17"
                      stroke="#1A1A1B"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                  >
                    <path
                      d="M9 1V17"
                      stroke="white"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M1 9H17"
                      stroke="white"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                )}
              </span>
              Create New Trial
            </button>
            <div className="relative" ref={dropdownRef}>
              <button
                onClick={() => {
                  setDropDown(!dropDown);
                }}
                onMouseEnter={() => {
                  setHover2(true);
                }}
                onMouseLeave={() => setHover2(false)}
                className={`flex items-center border border-blue-500 py-2 px-5 hover:bg-[#245CEA] transition duration-300 ml-5 rounded-[5px] ${
                  hover2 ? "text-[#ffffff]" : "text-[#1A1A1B]"
                } h-[42px] text-[16px] font-mont font-[600]`}
              >
                {hover2 ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    className="mr-[10px]"
                  >
                    <g clipPath="url(#clip0_1652_127617)">
                      <path
                        d="M7.33301 2.66602H2.66634C2.31272 2.66602 1.97358 2.80649 1.72353 3.05654C1.47348 3.30659 1.33301 3.64573 1.33301 3.99935V13.3327C1.33301 13.6863 1.47348 14.0254 1.72353 14.2755C1.97358 14.5255 2.31272 14.666 2.66634 14.666H11.9997C12.3533 14.666 12.6924 14.5255 12.9425 14.2755C13.1925 14.0254 13.333 13.6863 13.333 13.3327V8.66602"
                        stroke="white"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M12.333 1.66617C12.5982 1.40095 12.9579 1.25195 13.333 1.25195C13.7081 1.25195 14.0678 1.40095 14.333 1.66617C14.5982 1.93138 14.7472 2.29109 14.7472 2.66617C14.7472 3.04124 14.5982 3.40095 14.333 3.66617L7.99967 9.9995L5.33301 10.6662L5.99967 7.9995L12.333 1.66617Z"
                        stroke="white"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_1652_127617">
                        <rect width="16" height="16" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    className="mr-[10px]"
                  >
                    <g clipPath="url(#clip0_1652_127610)">
                      <path
                        d="M7.33301 2.66602H2.66634C2.31272 2.66602 1.97358 2.80649 1.72353 3.05654C1.47348 3.30659 1.33301 3.64573 1.33301 3.99935V13.3327C1.33301 13.6863 1.47348 14.0254 1.72353 14.2755C1.97358 14.5255 2.31272 14.666 2.66634 14.666H11.9997C12.3533 14.666 12.6924 14.5255 12.9425 14.2755C13.1925 14.0254 13.333 13.6863 13.333 13.3327V8.66602"
                        stroke="#1A1A1B"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M12.333 1.66617C12.5982 1.40095 12.9579 1.25195 13.333 1.25195C13.7081 1.25195 14.0678 1.40095 14.333 1.66617C14.5982 1.93138 14.7472 2.29109 14.7472 2.66617C14.7472 3.04124 14.5982 3.40095 14.333 3.66617L7.99967 9.9995L5.33301 10.6662L5.99967 7.9995L12.333 1.66617Z"
                        stroke="#1A1A1B"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_1652_127610">
                        <rect width="16" height="16" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                )}
                Edit an Existing Trials
                {hover2 ? (
                  <span class="relative ml-[10px]">
                    <svg
                      className="p-1"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M19.9201 8.94995L13.4001 15.47C12.6301 16.24 11.3701 16.24 10.6001 15.47L4.08008 8.94995"
                        stroke="white"
                        strokeWidth="2"
                        stroke-miterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                  </span>
                ) : (
                  <span class="relative ml-[10px]">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="p-1"
                    >
                      <path
                        d="M19.9201 8.94995L13.4001 15.47C12.6301 16.24 11.3701 16.24 10.6001 15.47L4.08008 8.94995"
                        stroke="#1A1A1B"
                        strokeWidth="2"
                        stroke-miterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                  </span>
                )}
              </button>
              {dropDown && (
                <div className="absolute right-0 mt-2 w-[280px] origin-top-right bg-white border border-gray-200 rounded-md shadow-lg z-30 overflow-hidden">
                  <div className="py-1 max-h-[400px] overflow-y-auto">
                    {trailData && trailData.length > 0 ? (
                      trailData.map((item) => (
                        <button
                          key={item.trialID}
                          className="block w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-100"
                          onClick={() => {
                            handleSelectChange(item.trialID);
                          }}
                        >
                          {item.trialName}
                        </button>
                      ))
                    ) : (
                      <div className="px-4 py-2 text-sm text-gray-500">
                        {trialIsLoading ? (
                          <div className="mini-spinner"></div>
                        ) : (
                          "No workflows available"
                        )}
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
          <div>
            <div className="relative" ref={locationDropdownRef}>
              <button
                onClick={() => {
                  setLocationDropDown(!locationDropDown);
                }}
                className={`flex w-[380px] justify-between items-center border border-blue-500 py-2 px-5  transition duration-300 ml-5 rounded-[5px]
                   text-[#1A1A1B]
                   h-[42px] text-[16px] font-mont font-[600]`}
              >
                <div className="flex items-center gap-2">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M14.7808 19.7005L14.1906 19.2377V19.2377L14.7808 19.7005ZM9.21921 19.7005L8.62903 20.1633L9.21921 19.7005ZM12 22.0055V21.2555V22.0055ZM20 9.6087H19.25C19.25 10.8352 18.6104 12.4764 17.6037 14.256C16.6137 16.0063 15.3342 17.7794 14.1906 19.2377L14.7808 19.7005L15.371 20.1633C16.5371 18.6762 17.8672 16.837 18.9094 14.9945C19.9349 13.1814 20.75 11.2494 20.75 9.6087H20ZM9.21921 19.7005L9.80938 19.2377C8.66578 17.7794 7.38628 16.0063 6.39625 14.256C5.38962 12.4764 4.75 10.8352 4.75 9.6087H4H3.25C3.25 11.2494 4.06511 13.1814 5.09064 14.9945C6.13277 16.837 7.46288 18.6762 8.62903 20.1633L9.21921 19.7005ZM4 9.6087H4.75C4.75 5.21571 8.04678 1.75 12 1.75V1V0.25C7.11666 0.25 3.25 4.49277 3.25 9.6087H4ZM12 1V1.75C15.9532 1.75 19.25 5.21571 19.25 9.6087H20H20.75C20.75 4.49277 16.8833 0.25 12 0.25V1ZM14.7808 19.7005L14.1906 19.2377C13.5717 20.027 13.1641 20.5426 12.7992 20.8741C12.4664 21.1764 12.2442 21.2555 12 21.2555V22.0055V22.7555C12.7291 22.7555 13.2948 22.4504 13.8078 21.9844C14.2886 21.5476 14.7849 20.9107 15.371 20.1633L14.7808 19.7005ZM9.21921 19.7005L8.62903 20.1633C9.21511 20.9107 9.71136 21.5476 10.1922 21.9844C10.7052 22.4504 11.2709 22.7555 12 22.7555V22.0055V21.2555C11.7558 21.2555 11.5336 21.1764 11.2008 20.8741C10.8359 20.5426 10.4283 20.027 9.80938 19.2377L9.21921 19.7005ZM9 10H8.25C8.25 12.0711 9.92893 13.75 12 13.75V13V12.25C10.7574 12.25 9.75 11.2426 9.75 10H9ZM12 13V13.75C14.0711 13.75 15.75 12.0711 15.75 10H15H14.25C14.25 11.2426 13.2426 12.25 12 12.25V13ZM15 10H15.75C15.75 7.92893 14.0711 6.25 12 6.25V7V7.75C13.2426 7.75 14.25 8.75736 14.25 10H15ZM12 7V6.25C9.92893 6.25 8.25 7.92893 8.25 10H9H9.75C9.75 8.75736 10.7574 7.75 12 7.75V7Z"
                      fill="#245CEA"
                    />
                  </svg>
                  <span className="w-[17rem] truncate text-left">
                    {clinicData &&
                    clinicData.length > 0 &&
                    clinicalInfoIds?.length > 0
                      ? clinicData
                          .filter((clinic) =>
                            clinicalInfoIds.includes(clinic.clinicalInfoID),
                          )
                          .map((clinic) => clinic.name)
                          .join(", ")
                      : "Select Location"}

                    {clinicalInfoIds?.length > 1 && (
                      <div className="group absolute top-[12px] right-[58px] w-[15px] h-[15px] bg-transparent cursor-pointer">
                        <div className="absolute hidden  border border-[#EEF2FE]  right-0 top-[-10px] w-max max-w-[30vw] whitespace-normal break-words text-[10px] rounded-lg shadow-lg bg-white z-[99] px-2 py-1 group-hover:block">
                          {clinicData
                            .filter((clinic) =>
                              clinicalInfoIds.includes(clinic.clinicalInfoID),
                            )
                            .map((clinic) => clinic.name)
                            .join(", ")}
                        </div>
                      </div>
                    )}
                  </span>
                </div>
                <span class="relative ml-[10px]">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="p-1"
                  >
                    <path
                      d="M19.9201 8.94995L13.4001 15.47C12.6301 16.24 11.3701 16.24 10.6001 15.47L4.08008 8.94995"
                      stroke="#1A1A1B"
                      strokeWidth="2"
                      stroke-miterlimit="10"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                </span>
              </button>
              {locationDropDown && (
                <div className="absolute right-0 mt-2 w-[380px] origin-top-right bg-white border border-gray-200 rounded-md shadow-lg z-30 overflow-hidden">
                  <div className="py-1 max-h-[400px] overflow-y-auto">
                    <label
                      //key={item.clinicalInfoID}
                      className="flex items-center gap-3 w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 cursor-pointer"
                    >
                      {/* Checkbox */}
                      <input
                        type="checkbox"
                        className="h-4 w-4"
                        checked={
                          clinicData &&
                          clinicalInfoIds.length == clinicData.length
                        }
                        onClick={() => handleToggleSelectAll()}
                      />

                      {/* Text / Button area */}
                      <button
                        type="button"
                        className="flex-1 text-left"
                        onClick={() => handleToggleSelectAll()}
                      >
                        {clinicalInfoIds.length === clinicData.length
                          ? "Deselect All"
                          : "Select All"}
                      </button>
                    </label>
                    {clinicData && clinicData.length > 0 ? (
                      clinicData.map((item) => (
                        <label
                          key={item.clinicalInfoID}
                          className="flex items-center gap-3 w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 cursor-pointer"
                        >
                          {/* Checkbox */}
                          <input
                            type="checkbox"
                            className="h-4 w-4"
                            checked={clinicalInfoIds.includes(
                              item.clinicalInfoID,
                            )}
                            onChange={() =>
                              handleLocationChange(item.clinicalInfoID)
                            }
                          />

                          {/* Text / Button area */}
                          <button
                            type="button"
                            className="flex-1 text-left"
                            onClick={() =>
                              handleLocationChange(item.clinicalInfoID)
                            }
                          >
                            {item.name}
                          </button>
                        </label>
                      ))
                    ) : (
                      <div className="px-4 py-2 text-sm text-gray-500">
                        {trialIsLoading ? (
                          <div className="mini-spinner"></div>
                        ) : (
                          "No location available"
                        )}
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        {/* <Link to="/create-trial" className="px-5 py-2 text-base rounded-md border primary_btn transition-all items-center duration-500 flex">Create Trial</Link> */}
        {/* <Link to="/trial/:id" className="px-5 py-1 text-base rounded-md border secondary_btn transition-all duration-500">Edit an Existing Trial</Link> */}
      </div>
      <div className="main-body mt-[30px] px-8">
        <div>
          {/* Tabs */}
          <div>
            <div className="flex cursor-pointer mb-[30px]">
              <div
                style={{ color: activeTab === "active" ? "#245CEA" : "black" }}
                className="text-[18px] text-center font-semibold"
                onClick={() => setActiveTab("active")}
              >
                Active
                {activeTab === "active" ? (
                  <div
                    className="border-b border-4 h-1 relative top-2 z-10 rounded-sm"
                    style={{ borderColor: "#245CEA" }}
                  ></div>
                ) : (
                  <div
                    className=" h-1 border-b border-4 relative top-2 z-10 rounded-sm"
                    style={{ borderColor: "#C8D6E6" }}
                  ></div>
                )}
              </div>
              <div
                style={{ color: activeTab === "active" ? "#245CEA" : "black" }}
                className="text-[18px] text-center font-semibold"
              >
                &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;
                <div
                  className=" h-1 border-b border-4 relative top-2 z-10 "
                  style={{ borderColor: "#C8D6E6" }}
                ></div>
              </div>

              <div
                // style={{ color: activeTab === 'completed' ? '#245CEA' : 'black' }}
                style={{
                  color: activeTab === "completed" ? "#245CEA" : "black",
                }}
                className="text-[18px] text-center font-semibold"
                onClick={() => setActiveTab("completed")}
              >
                Inactive
                {activeTab === "completed" ? (
                  <div
                    className="border-b border-4 h-1 relative top-2 z-10 rounded-sm"
                    style={{ borderColor: "#245CEA" }}
                  ></div>
                ) : (
                  <div
                    className=" h-1 border-b border-4 relative top-2 z-10 rounded-sm"
                    style={{ borderColor: "#C8D6E6" }}
                  ></div>
                )}
              </div>
            </div>
            {/*Tabs ended */}
            {/* <div className="bg-[#C8D6E6] h-[1px] border"></div> */}
          </div>

          {/* Tab Content */}
          {loading ? (
            <div className="w-full h-[30vh] ">
              <div className="spinner m-auto mt-[30vh]"></div>
            </div>
          ) : (
            <div className="mt-[1px]">
              {activeTab === "active" ? (
                <div>
                  {activeTtrialColumnData && activeTtrialColumnData.length ? (
                    <DataTable
                      columns={activeTrialColumnList}
                      data={activeTtrialColumnData}
                      customStyles={customStyles}
                    />
                  ) : (
                    <div className="p-1">
                      <div className=" rounded-lg border h-[60vh] ">
                        <div className="my-auto flex justify-center align-middle">
                          <div className="mt-[100px]">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="320"
                              height="200"
                              viewBox="0 0 320 200"
                              fill="none"
                            >
                              <g opacity="0.5">
                                <path
                                  d="M216.163 0.478397C160.252 -4.34316 145.454 28.8005 94.5917 31.7354C52.8986 34.1404 11.25 56.5336 2.46134 105.364C-6.42642 154.748 25.7659 192.637 37.3709 199.335L74.1957 199.585H258.145C273.139 199.712 286.9 199.478 286.9 199.478C321.586 165.338 328.135 92.1427 306.958 57.6433C284.586 21.199 242.301 2.73309 216.163 0.478397Z"
                                  fill="#EBEBFF"
                                />
                              </g>
                              <g>
                                <path
                                  d="M228.954 58.8533C227.774 60.9667 226.969 63.2249 226.541 65.5377L220.867 66.857L221.052 70.8355L221.236 74.8139L227.008 75.6023C227.65 77.865 228.659 80.0399 230.03 82.0349L226.95 86.9806L229.894 89.6637L232.838 92.3468L237.477 88.8229C239.591 90.0032 241.849 90.8076 244.162 91.2359L245.481 96.9097L249.459 96.7251L253.438 96.5406L254.226 90.7688C256.489 90.1274 258.664 89.118 260.659 87.7474L265.604 90.8269L268.288 87.8829L270.971 84.939L267.447 80.2997C268.627 78.1863 269.431 75.9282 269.86 73.6154L275.534 72.296L275.349 68.3176L275.164 64.3391L269.393 63.5496C268.751 61.2869 267.742 59.1119 266.371 57.117L269.451 52.1713L266.507 49.4882L263.563 46.8051L258.924 50.329C256.81 49.1487 254.552 48.3443 252.239 47.916L250.92 42.2422L246.941 42.4268L242.963 42.6113L242.175 48.3831C239.912 49.0245 237.737 50.0339 235.742 51.4045L230.796 48.325L228.113 51.2689L225.43 54.2129L228.954 58.8522V58.8533ZM251.952 55.113C259.941 57.1842 264.737 65.3406 262.665 73.3283C260.594 81.3171 252.437 86.1136 244.45 84.0412C236.461 81.9699 231.664 73.8136 233.737 65.8259C235.808 57.8371 243.964 53.0406 251.952 55.113Z"
                                  fill="#4563AA"
                                  fillOpacity="0.5"
                                />
                              </g>
                              <path
                                d="M45.758 68.2379C44.3134 70.8754 43.3359 73.6895 42.8254 76.5674L35.7891 78.2627L36.0579 83.205L36.3268 88.1473L43.5056 89.0702C44.3248 91.8751 45.6008 94.5673 47.3234 97.0328L43.5466 103.208L47.2312 106.512L50.9157 109.816L56.6453 105.392C59.2828 106.837 62.0969 107.814 64.9748 108.325L66.6701 115.361L71.6113 115.092L76.5536 114.823L77.4764 107.644C80.2814 106.825 82.9736 105.549 85.4391 103.827L91.6141 107.603L94.9181 103.919L98.2221 100.234L93.7982 94.5047C95.2428 91.8672 96.2204 89.0531 96.7308 86.1752L103.767 84.4799L103.498 79.5376L103.229 74.5964L96.0506 73.6735C95.2314 70.8686 93.9554 68.1764 92.2328 65.7109L96.0096 59.5358L92.325 56.2318L88.6405 52.9278L82.9109 57.3518C80.2734 55.9071 77.4593 54.9296 74.5814 54.4192L72.8861 47.3828L67.9438 47.6517L63.0015 47.9206L62.0786 55.0994C59.2737 55.9185 56.5815 57.1945 54.116 58.9172L47.9409 55.1404L44.6369 58.8249L41.3329 62.5094L45.7569 68.239L45.758 68.2379ZM74.2955 63.3616C84.2416 65.8567 90.2823 75.9419 87.7872 85.8881C85.2921 95.8342 75.2069 101.875 65.2607 99.3798C55.3146 96.8847 49.2739 86.7995 51.769 76.8533C54.2641 66.9072 64.3493 60.8665 74.2955 63.3616Z"
                                fill="#4563AA"
                                fillOpacity="0.5"
                              />
                              <g opacity="0.3">
                                <path
                                  d="M143.967 40.9733C142.149 44.2899 140.92 47.8297 140.279 51.4482L131.43 53.5809L131.768 59.7959L132.106 66.0108L141.134 67.1718C142.164 70.6991 143.77 74.0851 145.935 77.1852L141.186 84.9518L145.819 89.108L150.453 93.2642L157.659 87.6999C160.975 89.5171 164.515 90.7464 168.134 91.3878L170.266 100.237L176.481 99.8985L182.696 99.5601L183.857 90.5322C187.385 89.5022 190.771 87.897 193.871 85.7311L201.637 90.4809L205.794 85.8473L209.95 81.2138L204.385 74.0076C206.203 70.6911 207.432 67.1513 208.073 63.5328L216.922 61.4L216.584 55.1851L216.246 48.9702L207.218 47.8092C206.188 44.2819 204.583 40.8959 202.417 37.7958L207.166 30.0291L202.533 25.8729L197.899 21.7167L190.693 27.2811C187.377 25.4639 183.837 24.2346 180.218 23.5932L178.086 14.7441L171.871 15.0825L165.656 15.4209L164.495 24.4488C160.966 25.4787 157.581 27.084 154.481 29.2498L146.715 24.5001L142.558 29.1336L138.402 33.7672L143.967 40.9733ZM179.856 34.8416C192.365 37.9792 199.961 50.662 196.824 63.1716C193.686 75.6801 181.003 83.2771 168.494 80.1394C155.985 77.0017 148.388 64.3189 151.526 51.8093C154.664 39.3008 167.346 31.7039 179.856 34.8416Z"
                                  fill="#4563AA"
                                  fillOpacity="0.5"
                                />
                              </g>
                              <path
                                d="M222.848 33.9681C225.635 33.8086 232.169 33.5295 237.849 34.0092C240.198 34.2074 242.227 32.3298 242.175 29.9726C242.153 29.0076 241.807 27.8854 240.911 26.6128C237.462 21.7149 231.468 26.3929 231.525 28.8788C231.525 28.8788 230.313 25.1351 226.633 25.7902C222.952 26.4453 224.254 31.89 224.254 31.89C224.254 31.89 223.066 31.6394 222.243 32.2011C221.433 32.7536 221.87 34.024 222.848 33.9681Z"
                                fill="white"
                              />
                              <path
                                d="M37.1261 68.1332C39.587 67.992 45.3565 67.7459 50.3717 68.1697C52.4464 68.3451 54.2385 66.6874 54.1918 64.6059C54.1725 63.7537 53.8671 62.7625 53.0764 61.6392C50.0311 57.3143 44.7378 61.4443 44.7891 63.6398C44.7891 63.6398 43.7193 60.3346 40.4688 60.9134C37.2184 61.4922 38.3679 66.2989 38.3679 66.2989C38.3679 66.2989 37.3186 66.0768 36.5918 66.5735C35.8774 67.0611 36.2625 68.1834 37.1261 68.1332Z"
                                fill="white"
                              />
                              <path
                                d="M277.905 95.632C277.773 95.1876 277.82 94.6795 278.13 94.2568C278.689 93.4912 279.707 92.8418 281.531 92.7301C281.531 92.7301 279.559 83.9677 287.201 83.0483C295.055 82.1038 295.461 91.3379 295.461 91.3379C295.461 91.3379 299.913 86.4389 302.34 92.4077C302.34 92.4077 307.131 89.9901 309.432 92.8919C310.122 93.7601 310.005 94.9244 309.413 95.632H277.904H277.905Z"
                                fill="white"
                              />
                              <path
                                d="M29.6834 114.12C29.7825 113.788 29.7472 113.408 29.5159 113.091C29.0966 112.518 28.3356 112.033 26.9707 111.949C26.9707 111.949 28.4461 105.393 22.7279 104.705C16.8513 103.999 16.5483 110.907 16.5483 110.907C16.5483 110.907 13.2169 107.242 11.402 111.707C11.402 111.707 7.81773 109.898 6.09509 112.069C5.58013 112.719 5.66671 113.59 6.1099 114.119H29.6834V114.12Z"
                                fill="white"
                              />
                              <path
                                d="M104.04 53.5738C103.683 53.4895 103.333 53.7253 103.273 54.0819C103.273 54.0819 102.178 58.9445 101.944 59.6907L100.805 58.2666C100.642 57.959 100.26 57.8416 99.9526 58.0046C99.645 58.1675 99.5277 58.5491 99.6906 58.8568L101.161 62.6415C101.267 62.8421 101.701 62.9765 102.076 63.0016C105.54 64.363 105.877 65.115 106.844 65.3964L107.06 64.6365L108.093 60.985C108.393 59.8776 108.892 58.8328 109.566 57.9032L109.736 57.6696C109.949 57.3768 109.873 56.9621 109.56 56.765C109.277 56.5861 108.899 56.675 108.701 56.9461L107.474 58.638C107.436 58.6916 107.368 58.7132 107.306 58.695C107.213 58.6665 107.17 58.5605 107.216 58.4762L108.681 55.759C108.848 55.4479 108.709 55.1084 108.371 55.0036C108.033 54.8999 107.619 55.0697 107.452 55.3807L105.958 58.1515C105.924 58.2153 105.847 58.2472 105.778 58.2256L105.729 58.2108C105.648 58.1857 105.602 58.1003 105.628 58.0194L106.653 54.6823C106.752 54.361 106.596 54.0067 106.282 53.8871C105.937 53.7561 105.56 53.9452 105.453 54.2915L104.421 57.6491C104.396 57.73 104.311 57.7756 104.23 57.7505L104.072 57.7026C103.998 57.6799 103.954 57.6069 103.966 57.5306L104.512 54.312C104.568 53.9805 104.367 53.649 104.04 53.5715V53.5738Z"
                                fill="#FE9F73"
                              />
                              <path
                                d="M209.178 45.3164V199.03H94.7031V70.6102V45.3164H119.349H209.178Z"
                                fill="white"
                              />
                              <path
                                d="M150.78 72.275H202.327C202.728 72.275 203.053 71.7794 203.053 71.1688C203.053 70.5581 202.728 70.0625 202.327 70.0625H150.78C150.379 70.0625 150.055 70.557 150.055 71.1688C150.055 71.7794 150.379 72.275 150.78 72.275Z"
                                fill="#C8D6E6"
                              />
                              <path
                                d="M150.655 78.7106H202.202C202.603 78.7106 202.928 78.215 202.928 77.6043C202.928 76.9936 202.603 76.498 202.202 76.498H150.655C150.254 76.498 149.93 76.9936 149.93 77.6043C149.93 78.215 150.254 78.7106 150.655 78.7106Z"
                                fill="#C8D6E6"
                              />
                              <path
                                d="M150.655 84.7125H202.202C202.603 84.7125 202.928 84.2169 202.928 83.6063C202.928 82.9956 202.603 82.5 202.202 82.5H150.655C150.254 82.5 149.93 82.9945 149.93 83.6063C149.93 84.2169 150.254 84.7125 150.655 84.7125Z"
                                fill="#C8D6E6"
                              />
                              <path
                                d="M150.655 91.2106H202.202C202.603 91.2106 202.928 90.715 202.928 90.1043C202.928 89.4936 202.603 88.998 202.202 88.998H150.655C150.254 88.998 149.93 89.4936 149.93 90.1043C149.93 90.715 150.254 91.2106 150.655 91.2106Z"
                                fill="#C8D6E6"
                              />
                              <path
                                d="M150.78 137.775H202.327C202.728 137.775 203.053 137.279 203.053 136.669C203.053 136.058 202.728 135.562 202.327 135.562H150.78C150.379 135.562 150.055 136.057 150.055 136.669C150.055 137.279 150.379 137.775 150.78 137.775Z"
                                fill="#C8D6E6"
                              />
                              <path
                                d="M150.78 161.775H202.327C202.728 161.775 203.053 161.279 203.053 160.669C203.053 160.058 202.728 159.562 202.327 159.562H150.78C150.379 159.562 150.055 160.057 150.055 160.669C150.055 161.279 150.379 161.775 150.78 161.775Z"
                                fill="#C8D6E6"
                              />
                              <path
                                d="M150.655 120.211H202.202C202.603 120.211 202.928 119.715 202.928 119.104C202.928 118.494 202.603 117.998 202.202 117.998H150.655C150.254 117.998 149.93 118.494 149.93 119.104C149.93 119.715 150.254 120.211 150.655 120.211Z"
                                fill="#C8D6E6"
                              />
                              <path
                                d="M150.655 144.211H202.202C202.603 144.211 202.928 143.715 202.928 143.104C202.928 142.494 202.603 141.998 202.202 141.998H150.655C150.254 141.998 149.93 142.494 149.93 143.104C149.93 143.715 150.254 144.211 150.655 144.211Z"
                                fill="#C8D6E6"
                              />
                              <path
                                d="M150.655 168.211H202.202C202.603 168.211 202.928 167.715 202.928 167.104C202.928 166.494 202.603 165.998 202.202 165.998H150.655C150.254 165.998 149.93 166.494 149.93 167.104C149.93 167.715 150.254 168.211 150.655 168.211Z"
                                fill="#C8D6E6"
                              />
                              <path
                                d="M150.655 126.211H202.202C202.603 126.211 202.928 125.715 202.928 125.104C202.928 124.494 202.603 123.998 202.202 123.998H150.655C150.254 123.998 149.93 124.493 149.93 125.104C149.93 125.715 150.254 126.211 150.655 126.211Z"
                                fill="#C8D6E6"
                              />
                              <path
                                d="M150.655 150.211H202.202C202.603 150.211 202.928 149.715 202.928 149.104C202.928 148.494 202.603 147.998 202.202 147.998H150.655C150.254 147.998 149.93 148.493 149.93 149.104C149.93 149.715 150.254 150.211 150.655 150.211Z"
                                fill="#C8D6E6"
                              />
                              <path
                                d="M150.655 174.211H202.202C202.603 174.211 202.928 173.715 202.928 173.104C202.928 172.494 202.603 171.998 202.202 171.998H150.655C150.254 171.998 149.93 172.493 149.93 173.104C149.93 173.715 150.254 174.211 150.655 174.211Z"
                                fill="#C8D6E6"
                              />
                              <path
                                d="M150.655 132.711H202.202C202.603 132.711 202.928 132.215 202.928 131.604C202.928 130.994 202.603 130.498 202.202 130.498H150.655C150.254 130.498 149.93 130.994 149.93 131.604C149.93 132.215 150.254 132.711 150.655 132.711Z"
                                fill="#C8D6E6"
                              />
                              <path
                                d="M150.655 180.711H202.202C202.603 180.711 202.928 180.215 202.928 179.604C202.928 178.994 202.603 178.498 202.202 178.498H150.655C150.254 178.498 149.93 178.994 149.93 179.604C149.93 180.215 150.254 180.711 150.655 180.711Z"
                                fill="#C8D6E6"
                              />
                              <path
                                d="M102.326 96.998H201.532C202.304 96.998 202.929 96.5501 202.929 95.998C202.929 95.446 202.304 94.998 201.532 94.998H102.326C101.555 94.998 100.93 95.445 100.93 95.998C100.93 96.5501 101.555 96.998 102.326 96.998Z"
                                fill="#C8D6E6"
                              />
                              <path
                                d="M102.326 102H201.532C202.304 102 202.929 101.552 202.929 101C202.929 100.448 202.304 100 201.532 100H102.326C101.555 100 100.93 100.447 100.93 101C100.93 101.552 101.555 102 102.326 102Z"
                                fill="#C8D6E6"
                              />
                              <path
                                d="M102.326 106.998H201.532C202.304 106.998 202.929 106.55 202.929 105.998C202.929 105.446 202.304 104.998 201.532 104.998H102.326C101.555 104.998 100.93 105.445 100.93 105.998C100.93 106.55 101.555 106.998 102.326 106.998Z"
                                fill="#C8D6E6"
                              />
                              <path
                                d="M101.551 72.2106H145.632C145.975 72.2106 146.253 71.715 146.253 71.1043C146.253 70.4936 145.975 69.998 145.632 69.998H101.551C101.208 69.998 100.93 70.4936 100.93 71.1043C100.93 71.715 101.208 72.2106 101.551 72.2106Z"
                                fill="#C8D6E6"
                              />
                              <path
                                d="M101.551 78.4879H145.632C145.975 78.4879 146.253 77.9923 146.253 77.3817C146.253 76.771 145.975 76.2754 145.632 76.2754H101.551C101.208 76.2754 100.93 76.7698 100.93 77.3817C100.93 77.9923 101.208 78.4879 101.551 78.4879Z"
                                fill="#C8D6E6"
                              />
                              <path
                                d="M101.551 84.7633H145.632C145.975 84.7633 146.253 84.2677 146.253 83.657C146.253 83.0464 145.975 82.5508 145.632 82.5508H101.551C101.208 82.5508 100.93 83.0464 100.93 83.657C100.93 84.2677 101.208 84.7633 101.551 84.7633Z"
                                fill="#C8D6E6"
                              />
                              <path
                                d="M101.551 91.0387H145.632C145.975 91.0387 146.253 90.5431 146.253 89.9325C146.253 89.3218 145.975 88.8262 145.632 88.8262H101.551C101.208 88.8262 100.93 89.3218 100.93 89.9325C100.93 90.5431 101.208 91.0387 101.551 91.0387Z"
                                fill="#C8D6E6"
                              />
                              <path
                                d="M101.551 137.711H145.632C145.975 137.711 146.253 137.215 146.253 136.604C146.253 135.994 145.975 135.498 145.632 135.498H101.551C101.208 135.498 100.93 135.994 100.93 136.604C100.93 137.215 101.208 137.711 101.551 137.711Z"
                                fill="#C8D6E6"
                              />
                              <path
                                d="M101.551 161.711H145.632C145.975 161.711 146.253 161.215 146.253 160.604C146.253 159.994 145.975 159.498 145.632 159.498H101.551C101.208 159.498 100.93 159.994 100.93 160.604C100.93 161.215 101.208 161.711 101.551 161.711Z"
                                fill="#C8D6E6"
                              />
                              <path
                                d="M101.551 119.988H145.632C145.975 119.988 146.253 119.492 146.253 118.882C146.253 118.271 145.975 117.775 145.632 117.775H101.551C101.208 117.775 100.93 118.27 100.93 118.882C100.93 119.492 101.208 119.988 101.551 119.988Z"
                                fill="#C8D6E6"
                              />
                              <path
                                d="M101.551 143.988H145.632C145.975 143.988 146.253 143.492 146.253 142.882C146.253 142.271 145.975 141.775 145.632 141.775H101.551C101.208 141.775 100.93 142.27 100.93 142.882C100.93 143.492 101.208 143.988 101.551 143.988Z"
                                fill="#C8D6E6"
                              />
                              <path
                                d="M101.551 167.988H145.632C145.975 167.988 146.253 167.492 146.253 166.882C146.253 166.271 145.975 165.775 145.632 165.775H101.551C101.208 165.775 100.93 166.27 100.93 166.882C100.93 167.492 101.208 167.988 101.551 167.988Z"
                                fill="#C8D6E6"
                              />
                              <path
                                d="M101.551 126.263H145.632C145.975 126.263 146.253 125.768 146.253 125.157C146.253 124.546 145.975 124.051 145.632 124.051H101.551C101.208 124.051 100.93 124.546 100.93 125.157C100.93 125.768 101.208 126.263 101.551 126.263Z"
                                fill="#C8D6E6"
                              />
                              <path
                                d="M101.551 150.263H145.632C145.975 150.263 146.253 149.768 146.253 149.157C146.253 148.546 145.975 148.051 145.632 148.051H101.551C101.208 148.051 100.93 148.546 100.93 149.157C100.93 149.768 101.208 150.263 101.551 150.263Z"
                                fill="#C8D6E6"
                              />
                              <path
                                d="M101.551 174.263H145.632C145.975 174.263 146.253 173.768 146.253 173.157C146.253 172.546 145.975 172.051 145.632 172.051H101.551C101.208 172.051 100.93 172.546 100.93 173.157C100.93 173.768 101.208 174.263 101.551 174.263Z"
                                fill="#C8D6E6"
                              />
                              <path
                                d="M101.551 132.539H145.632C145.975 132.539 146.253 132.043 146.253 131.432C146.253 130.822 145.975 130.326 145.632 130.326H101.551C101.208 130.326 100.93 130.822 100.93 131.432C100.93 132.043 101.208 132.539 101.551 132.539Z"
                                fill="#C8D6E6"
                              />
                              <path
                                d="M101.551 180.539H145.632C145.975 180.539 146.253 180.043 146.253 179.432C146.253 178.822 145.975 178.326 145.632 178.326H101.551C101.208 178.326 100.93 178.822 100.93 179.432C100.93 180.043 101.208 180.539 101.551 180.539Z"
                                fill="#C8D6E6"
                              />
                              <path
                                d="M202.929 54.498H100.93V63.998H202.929V54.498Z"
                                fill="#C8D6E6"
                              />
                              <path
                                d="M122.43 188.998H100.93V196.998H122.43V188.998Z"
                                fill="#C8D6E6"
                              />
                              <path
                                d="M146.43 188.998H124.93V196.998H146.43V188.998Z"
                                fill="#C8D6E6"
                              />
                            </svg>
                          </div>
                        </div>
                        <div className="font-mont text-[18px] font-[400] mt-5 text-center">
                          No Active trials are available. Please create a new
                          trial.
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              ) : (
                <div>
                  <div>
                    {completedTtrialColumnData &&
                    completedTtrialColumnData.length ? (
                      <DataTable
                        columns={activeTrialColumnList}
                        data={completedTtrialColumnData}
                        customStyles={customStyles}
                      />
                    ) : (
                      <div className="p-1">
                        <div className=" rounded-lg border h-[60vh] ">
                          <div className="my-auto flex justify-center align-middle">
                            <div className="mt-[100px]">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="320"
                                height="200"
                                viewBox="0 0 320 200"
                                fill="none"
                              >
                                <g opacity="0.5">
                                  <path
                                    d="M216.163 0.478397C160.252 -4.34316 145.454 28.8005 94.5917 31.7354C52.8986 34.1404 11.25 56.5336 2.46134 105.364C-6.42642 154.748 25.7659 192.637 37.3709 199.335L74.1957 199.585H258.145C273.139 199.712 286.9 199.478 286.9 199.478C321.586 165.338 328.135 92.1427 306.958 57.6433C284.586 21.199 242.301 2.73309 216.163 0.478397Z"
                                    fill="#EBEBFF"
                                  />
                                </g>
                                <g>
                                  <path
                                    d="M228.954 58.8533C227.774 60.9667 226.969 63.2249 226.541 65.5377L220.867 66.857L221.052 70.8355L221.236 74.8139L227.008 75.6023C227.65 77.865 228.659 80.0399 230.03 82.0349L226.95 86.9806L229.894 89.6637L232.838 92.3468L237.477 88.8229C239.591 90.0032 241.849 90.8076 244.162 91.2359L245.481 96.9097L249.459 96.7251L253.438 96.5406L254.226 90.7688C256.489 90.1274 258.664 89.118 260.659 87.7474L265.604 90.8269L268.288 87.8829L270.971 84.939L267.447 80.2997C268.627 78.1863 269.431 75.9282 269.86 73.6154L275.534 72.296L275.349 68.3176L275.164 64.3391L269.393 63.5496C268.751 61.2869 267.742 59.1119 266.371 57.117L269.451 52.1713L266.507 49.4882L263.563 46.8051L258.924 50.329C256.81 49.1487 254.552 48.3443 252.239 47.916L250.92 42.2422L246.941 42.4268L242.963 42.6113L242.175 48.3831C239.912 49.0245 237.737 50.0339 235.742 51.4045L230.796 48.325L228.113 51.2689L225.43 54.2129L228.954 58.8522V58.8533ZM251.952 55.113C259.941 57.1842 264.737 65.3406 262.665 73.3283C260.594 81.3171 252.437 86.1136 244.45 84.0412C236.461 81.9699 231.664 73.8136 233.737 65.8259C235.808 57.8371 243.964 53.0406 251.952 55.113Z"
                                    fill="#4563AA"
                                    fillOpacity="0.5"
                                  />
                                </g>
                                <path
                                  d="M45.758 68.2379C44.3134 70.8754 43.3359 73.6895 42.8254 76.5674L35.7891 78.2627L36.0579 83.205L36.3268 88.1473L43.5056 89.0702C44.3248 91.8751 45.6008 94.5673 47.3234 97.0328L43.5466 103.208L47.2312 106.512L50.9157 109.816L56.6453 105.392C59.2828 106.837 62.0969 107.814 64.9748 108.325L66.6701 115.361L71.6113 115.092L76.5536 114.823L77.4764 107.644C80.2814 106.825 82.9736 105.549 85.4391 103.827L91.6141 107.603L94.9181 103.919L98.2221 100.234L93.7982 94.5047C95.2428 91.8672 96.2204 89.0531 96.7308 86.1752L103.767 84.4799L103.498 79.5376L103.229 74.5964L96.0506 73.6735C95.2314 70.8686 93.9554 68.1764 92.2328 65.7109L96.0096 59.5358L92.325 56.2318L88.6405 52.9278L82.9109 57.3518C80.2734 55.9071 77.4593 54.9296 74.5814 54.4192L72.8861 47.3828L67.9438 47.6517L63.0015 47.9206L62.0786 55.0994C59.2737 55.9185 56.5815 57.1945 54.116 58.9172L47.9409 55.1404L44.6369 58.8249L41.3329 62.5094L45.7569 68.239L45.758 68.2379ZM74.2955 63.3616C84.2416 65.8567 90.2823 75.9419 87.7872 85.8881C85.2921 95.8342 75.2069 101.875 65.2607 99.3798C55.3146 96.8847 49.2739 86.7995 51.769 76.8533C54.2641 66.9072 64.3493 60.8665 74.2955 63.3616Z"
                                  fill="#4563AA"
                                  fillOpacity="0.5"
                                />
                                <g opacity="0.3">
                                  <path
                                    d="M143.967 40.9733C142.149 44.2899 140.92 47.8297 140.279 51.4482L131.43 53.5809L131.768 59.7959L132.106 66.0108L141.134 67.1718C142.164 70.6991 143.77 74.0851 145.935 77.1852L141.186 84.9518L145.819 89.108L150.453 93.2642L157.659 87.6999C160.975 89.5171 164.515 90.7464 168.134 91.3878L170.266 100.237L176.481 99.8985L182.696 99.5601L183.857 90.5322C187.385 89.5022 190.771 87.897 193.871 85.7311L201.637 90.4809L205.794 85.8473L209.95 81.2138L204.385 74.0076C206.203 70.6911 207.432 67.1513 208.073 63.5328L216.922 61.4L216.584 55.1851L216.246 48.9702L207.218 47.8092C206.188 44.2819 204.583 40.8959 202.417 37.7958L207.166 30.0291L202.533 25.8729L197.899 21.7167L190.693 27.2811C187.377 25.4639 183.837 24.2346 180.218 23.5932L178.086 14.7441L171.871 15.0825L165.656 15.4209L164.495 24.4488C160.966 25.4787 157.581 27.084 154.481 29.2498L146.715 24.5001L142.558 29.1336L138.402 33.7672L143.967 40.9733ZM179.856 34.8416C192.365 37.9792 199.961 50.662 196.824 63.1716C193.686 75.6801 181.003 83.2771 168.494 80.1394C155.985 77.0017 148.388 64.3189 151.526 51.8093C154.664 39.3008 167.346 31.7039 179.856 34.8416Z"
                                    fill="#4563AA"
                                    fillOpacity="0.5"
                                  />
                                </g>
                                <path
                                  d="M222.848 33.9681C225.635 33.8086 232.169 33.5295 237.849 34.0092C240.198 34.2074 242.227 32.3298 242.175 29.9726C242.153 29.0076 241.807 27.8854 240.911 26.6128C237.462 21.7149 231.468 26.3929 231.525 28.8788C231.525 28.8788 230.313 25.1351 226.633 25.7902C222.952 26.4453 224.254 31.89 224.254 31.89C224.254 31.89 223.066 31.6394 222.243 32.2011C221.433 32.7536 221.87 34.024 222.848 33.9681Z"
                                  fill="white"
                                />
                                <path
                                  d="M37.1261 68.1332C39.587 67.992 45.3565 67.7459 50.3717 68.1697C52.4464 68.3451 54.2385 66.6874 54.1918 64.6059C54.1725 63.7537 53.8671 62.7625 53.0764 61.6392C50.0311 57.3143 44.7378 61.4443 44.7891 63.6398C44.7891 63.6398 43.7193 60.3346 40.4688 60.9134C37.2184 61.4922 38.3679 66.2989 38.3679 66.2989C38.3679 66.2989 37.3186 66.0768 36.5918 66.5735C35.8774 67.0611 36.2625 68.1834 37.1261 68.1332Z"
                                  fill="white"
                                />
                                <path
                                  d="M277.905 95.632C277.773 95.1876 277.82 94.6795 278.13 94.2568C278.689 93.4912 279.707 92.8418 281.531 92.7301C281.531 92.7301 279.559 83.9677 287.201 83.0483C295.055 82.1038 295.461 91.3379 295.461 91.3379C295.461 91.3379 299.913 86.4389 302.34 92.4077C302.34 92.4077 307.131 89.9901 309.432 92.8919C310.122 93.7601 310.005 94.9244 309.413 95.632H277.904H277.905Z"
                                  fill="white"
                                />
                                <path
                                  d="M29.6834 114.12C29.7825 113.788 29.7472 113.408 29.5159 113.091C29.0966 112.518 28.3356 112.033 26.9707 111.949C26.9707 111.949 28.4461 105.393 22.7279 104.705C16.8513 103.999 16.5483 110.907 16.5483 110.907C16.5483 110.907 13.2169 107.242 11.402 111.707C11.402 111.707 7.81773 109.898 6.09509 112.069C5.58013 112.719 5.66671 113.59 6.1099 114.119H29.6834V114.12Z"
                                  fill="white"
                                />
                                <path
                                  d="M104.04 53.5738C103.683 53.4895 103.333 53.7253 103.273 54.0819C103.273 54.0819 102.178 58.9445 101.944 59.6907L100.805 58.2666C100.642 57.959 100.26 57.8416 99.9526 58.0046C99.645 58.1675 99.5277 58.5491 99.6906 58.8568L101.161 62.6415C101.267 62.8421 101.701 62.9765 102.076 63.0016C105.54 64.363 105.877 65.115 106.844 65.3964L107.06 64.6365L108.093 60.985C108.393 59.8776 108.892 58.8328 109.566 57.9032L109.736 57.6696C109.949 57.3768 109.873 56.9621 109.56 56.765C109.277 56.5861 108.899 56.675 108.701 56.9461L107.474 58.638C107.436 58.6916 107.368 58.7132 107.306 58.695C107.213 58.6665 107.17 58.5605 107.216 58.4762L108.681 55.759C108.848 55.4479 108.709 55.1084 108.371 55.0036C108.033 54.8999 107.619 55.0697 107.452 55.3807L105.958 58.1515C105.924 58.2153 105.847 58.2472 105.778 58.2256L105.729 58.2108C105.648 58.1857 105.602 58.1003 105.628 58.0194L106.653 54.6823C106.752 54.361 106.596 54.0067 106.282 53.8871C105.937 53.7561 105.56 53.9452 105.453 54.2915L104.421 57.6491C104.396 57.73 104.311 57.7756 104.23 57.7505L104.072 57.7026C103.998 57.6799 103.954 57.6069 103.966 57.5306L104.512 54.312C104.568 53.9805 104.367 53.649 104.04 53.5715V53.5738Z"
                                  fill="#FE9F73"
                                />
                                <path
                                  d="M209.178 45.3164V199.03H94.7031V70.6102V45.3164H119.349H209.178Z"
                                  fill="white"
                                />
                                <path
                                  d="M150.78 72.275H202.327C202.728 72.275 203.053 71.7794 203.053 71.1688C203.053 70.5581 202.728 70.0625 202.327 70.0625H150.78C150.379 70.0625 150.055 70.557 150.055 71.1688C150.055 71.7794 150.379 72.275 150.78 72.275Z"
                                  fill="#C8D6E6"
                                />
                                <path
                                  d="M150.655 78.7106H202.202C202.603 78.7106 202.928 78.215 202.928 77.6043C202.928 76.9936 202.603 76.498 202.202 76.498H150.655C150.254 76.498 149.93 76.9936 149.93 77.6043C149.93 78.215 150.254 78.7106 150.655 78.7106Z"
                                  fill="#C8D6E6"
                                />
                                <path
                                  d="M150.655 84.7125H202.202C202.603 84.7125 202.928 84.2169 202.928 83.6063C202.928 82.9956 202.603 82.5 202.202 82.5H150.655C150.254 82.5 149.93 82.9945 149.93 83.6063C149.93 84.2169 150.254 84.7125 150.655 84.7125Z"
                                  fill="#C8D6E6"
                                />
                                <path
                                  d="M150.655 91.2106H202.202C202.603 91.2106 202.928 90.715 202.928 90.1043C202.928 89.4936 202.603 88.998 202.202 88.998H150.655C150.254 88.998 149.93 89.4936 149.93 90.1043C149.93 90.715 150.254 91.2106 150.655 91.2106Z"
                                  fill="#C8D6E6"
                                />
                                <path
                                  d="M150.78 137.775H202.327C202.728 137.775 203.053 137.279 203.053 136.669C203.053 136.058 202.728 135.562 202.327 135.562H150.78C150.379 135.562 150.055 136.057 150.055 136.669C150.055 137.279 150.379 137.775 150.78 137.775Z"
                                  fill="#C8D6E6"
                                />
                                <path
                                  d="M150.78 161.775H202.327C202.728 161.775 203.053 161.279 203.053 160.669C203.053 160.058 202.728 159.562 202.327 159.562H150.78C150.379 159.562 150.055 160.057 150.055 160.669C150.055 161.279 150.379 161.775 150.78 161.775Z"
                                  fill="#C8D6E6"
                                />
                                <path
                                  d="M150.655 120.211H202.202C202.603 120.211 202.928 119.715 202.928 119.104C202.928 118.494 202.603 117.998 202.202 117.998H150.655C150.254 117.998 149.93 118.494 149.93 119.104C149.93 119.715 150.254 120.211 150.655 120.211Z"
                                  fill="#C8D6E6"
                                />
                                <path
                                  d="M150.655 144.211H202.202C202.603 144.211 202.928 143.715 202.928 143.104C202.928 142.494 202.603 141.998 202.202 141.998H150.655C150.254 141.998 149.93 142.494 149.93 143.104C149.93 143.715 150.254 144.211 150.655 144.211Z"
                                  fill="#C8D6E6"
                                />
                                <path
                                  d="M150.655 168.211H202.202C202.603 168.211 202.928 167.715 202.928 167.104C202.928 166.494 202.603 165.998 202.202 165.998H150.655C150.254 165.998 149.93 166.494 149.93 167.104C149.93 167.715 150.254 168.211 150.655 168.211Z"
                                  fill="#C8D6E6"
                                />
                                <path
                                  d="M150.655 126.211H202.202C202.603 126.211 202.928 125.715 202.928 125.104C202.928 124.494 202.603 123.998 202.202 123.998H150.655C150.254 123.998 149.93 124.493 149.93 125.104C149.93 125.715 150.254 126.211 150.655 126.211Z"
                                  fill="#C8D6E6"
                                />
                                <path
                                  d="M150.655 150.211H202.202C202.603 150.211 202.928 149.715 202.928 149.104C202.928 148.494 202.603 147.998 202.202 147.998H150.655C150.254 147.998 149.93 148.493 149.93 149.104C149.93 149.715 150.254 150.211 150.655 150.211Z"
                                  fill="#C8D6E6"
                                />
                                <path
                                  d="M150.655 174.211H202.202C202.603 174.211 202.928 173.715 202.928 173.104C202.928 172.494 202.603 171.998 202.202 171.998H150.655C150.254 171.998 149.93 172.493 149.93 173.104C149.93 173.715 150.254 174.211 150.655 174.211Z"
                                  fill="#C8D6E6"
                                />
                                <path
                                  d="M150.655 132.711H202.202C202.603 132.711 202.928 132.215 202.928 131.604C202.928 130.994 202.603 130.498 202.202 130.498H150.655C150.254 130.498 149.93 130.994 149.93 131.604C149.93 132.215 150.254 132.711 150.655 132.711Z"
                                  fill="#C8D6E6"
                                />
                                <path
                                  d="M150.655 180.711H202.202C202.603 180.711 202.928 180.215 202.928 179.604C202.928 178.994 202.603 178.498 202.202 178.498H150.655C150.254 178.498 149.93 178.994 149.93 179.604C149.93 180.215 150.254 180.711 150.655 180.711Z"
                                  fill="#C8D6E6"
                                />
                                <path
                                  d="M102.326 96.998H201.532C202.304 96.998 202.929 96.5501 202.929 95.998C202.929 95.446 202.304 94.998 201.532 94.998H102.326C101.555 94.998 100.93 95.445 100.93 95.998C100.93 96.5501 101.555 96.998 102.326 96.998Z"
                                  fill="#C8D6E6"
                                />
                                <path
                                  d="M102.326 102H201.532C202.304 102 202.929 101.552 202.929 101C202.929 100.448 202.304 100 201.532 100H102.326C101.555 100 100.93 100.447 100.93 101C100.93 101.552 101.555 102 102.326 102Z"
                                  fill="#C8D6E6"
                                />
                                <path
                                  d="M102.326 106.998H201.532C202.304 106.998 202.929 106.55 202.929 105.998C202.929 105.446 202.304 104.998 201.532 104.998H102.326C101.555 104.998 100.93 105.445 100.93 105.998C100.93 106.55 101.555 106.998 102.326 106.998Z"
                                  fill="#C8D6E6"
                                />
                                <path
                                  d="M101.551 72.2106H145.632C145.975 72.2106 146.253 71.715 146.253 71.1043C146.253 70.4936 145.975 69.998 145.632 69.998H101.551C101.208 69.998 100.93 70.4936 100.93 71.1043C100.93 71.715 101.208 72.2106 101.551 72.2106Z"
                                  fill="#C8D6E6"
                                />
                                <path
                                  d="M101.551 78.4879H145.632C145.975 78.4879 146.253 77.9923 146.253 77.3817C146.253 76.771 145.975 76.2754 145.632 76.2754H101.551C101.208 76.2754 100.93 76.7698 100.93 77.3817C100.93 77.9923 101.208 78.4879 101.551 78.4879Z"
                                  fill="#C8D6E6"
                                />
                                <path
                                  d="M101.551 84.7633H145.632C145.975 84.7633 146.253 84.2677 146.253 83.657C146.253 83.0464 145.975 82.5508 145.632 82.5508H101.551C101.208 82.5508 100.93 83.0464 100.93 83.657C100.93 84.2677 101.208 84.7633 101.551 84.7633Z"
                                  fill="#C8D6E6"
                                />
                                <path
                                  d="M101.551 91.0387H145.632C145.975 91.0387 146.253 90.5431 146.253 89.9325C146.253 89.3218 145.975 88.8262 145.632 88.8262H101.551C101.208 88.8262 100.93 89.3218 100.93 89.9325C100.93 90.5431 101.208 91.0387 101.551 91.0387Z"
                                  fill="#C8D6E6"
                                />
                                <path
                                  d="M101.551 137.711H145.632C145.975 137.711 146.253 137.215 146.253 136.604C146.253 135.994 145.975 135.498 145.632 135.498H101.551C101.208 135.498 100.93 135.994 100.93 136.604C100.93 137.215 101.208 137.711 101.551 137.711Z"
                                  fill="#C8D6E6"
                                />
                                <path
                                  d="M101.551 161.711H145.632C145.975 161.711 146.253 161.215 146.253 160.604C146.253 159.994 145.975 159.498 145.632 159.498H101.551C101.208 159.498 100.93 159.994 100.93 160.604C100.93 161.215 101.208 161.711 101.551 161.711Z"
                                  fill="#C8D6E6"
                                />
                                <path
                                  d="M101.551 119.988H145.632C145.975 119.988 146.253 119.492 146.253 118.882C146.253 118.271 145.975 117.775 145.632 117.775H101.551C101.208 117.775 100.93 118.27 100.93 118.882C100.93 119.492 101.208 119.988 101.551 119.988Z"
                                  fill="#C8D6E6"
                                />
                                <path
                                  d="M101.551 143.988H145.632C145.975 143.988 146.253 143.492 146.253 142.882C146.253 142.271 145.975 141.775 145.632 141.775H101.551C101.208 141.775 100.93 142.27 100.93 142.882C100.93 143.492 101.208 143.988 101.551 143.988Z"
                                  fill="#C8D6E6"
                                />
                                <path
                                  d="M101.551 167.988H145.632C145.975 167.988 146.253 167.492 146.253 166.882C146.253 166.271 145.975 165.775 145.632 165.775H101.551C101.208 165.775 100.93 166.27 100.93 166.882C100.93 167.492 101.208 167.988 101.551 167.988Z"
                                  fill="#C8D6E6"
                                />
                                <path
                                  d="M101.551 126.263H145.632C145.975 126.263 146.253 125.768 146.253 125.157C146.253 124.546 145.975 124.051 145.632 124.051H101.551C101.208 124.051 100.93 124.546 100.93 125.157C100.93 125.768 101.208 126.263 101.551 126.263Z"
                                  fill="#C8D6E6"
                                />
                                <path
                                  d="M101.551 150.263H145.632C145.975 150.263 146.253 149.768 146.253 149.157C146.253 148.546 145.975 148.051 145.632 148.051H101.551C101.208 148.051 100.93 148.546 100.93 149.157C100.93 149.768 101.208 150.263 101.551 150.263Z"
                                  fill="#C8D6E6"
                                />
                                <path
                                  d="M101.551 174.263H145.632C145.975 174.263 146.253 173.768 146.253 173.157C146.253 172.546 145.975 172.051 145.632 172.051H101.551C101.208 172.051 100.93 172.546 100.93 173.157C100.93 173.768 101.208 174.263 101.551 174.263Z"
                                  fill="#C8D6E6"
                                />
                                <path
                                  d="M101.551 132.539H145.632C145.975 132.539 146.253 132.043 146.253 131.432C146.253 130.822 145.975 130.326 145.632 130.326H101.551C101.208 130.326 100.93 130.822 100.93 131.432C100.93 132.043 101.208 132.539 101.551 132.539Z"
                                  fill="#C8D6E6"
                                />
                                <path
                                  d="M101.551 180.539H145.632C145.975 180.539 146.253 180.043 146.253 179.432C146.253 178.822 145.975 178.326 145.632 178.326H101.551C101.208 178.326 100.93 178.822 100.93 179.432C100.93 180.043 101.208 180.539 101.551 180.539Z"
                                  fill="#C8D6E6"
                                />
                                <path
                                  d="M202.929 54.498H100.93V63.998H202.929V54.498Z"
                                  fill="#C8D6E6"
                                />
                                <path
                                  d="M122.43 188.998H100.93V196.998H122.43V188.998Z"
                                  fill="#C8D6E6"
                                />
                                <path
                                  d="M146.43 188.998H124.93V196.998H146.43V188.998Z"
                                  fill="#C8D6E6"
                                />
                              </svg>
                            </div>
                          </div>
                          <div className="font-mont text-[18px] font-[400] mt-5 text-center">
                            No Inactive trials are available. Please create a
                            new trial.
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
        {isDelete && (
          <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-lg max-w-lg w-full p-6 relative">
              <div>
                <div>
                  <div className="flex flex-row mt-2 text-sm items-center">
                    <span
                      className={`${
                        isDelete.isActive
                          ? "delete-popup-bg"
                          : "reactive-popup-bg"
                      } item-center`}
                    >
                      {isDelete.isActive ? (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M19.704 6H18.837C16.9005 6 16.9035 3 15.5355 3H7.2945C5.7525 3 4.5 4.2525 4.5 5.796V9H6V5.796C6 5.082 6.582 4.5 7.2945 4.5H15.2505C15.3435 4.644 15.462 4.86 15.5475 5.0205C16.05 5.9475 16.8915 7.5 18.837 7.5H19.704C20.37 7.5 21 8.229 21 9V18.2055C21 18.918 20.418 19.5 19.704 19.5H7.2945C6.582 19.5 6 18.918 6 18.2055V16.5H4.5V18.2055C4.5 19.749 5.7525 21 7.2945 21H19.7025C21.2475 21 22.5 19.749 22.5 18.2055V9C22.5 7.4565 21.2475 6 19.704 6Z"
                            fill="#DC3545"
                          />
                          <path
                            d="M11.6583 16.259L14.7768 13.2155C14.7798 13.2125 14.7813 13.208 14.7843 13.2035C14.8503 13.1375 14.9058 12.98 14.9433 12.893C14.9748 12.812 14.9868 12.878 14.9928 12.797C14.9928 12.779 15.0018 12.764 15.0018 12.7475C15.0018 12.7355 14.9958 12.7265 14.9958 12.716C14.9913 12.626 14.9748 12.581 14.9433 12.497C14.9118 12.4205 14.8608 12.356 14.8083 12.2945C14.7963 12.2795 14.7903 12.2585 14.7768 12.245L11.6583 9.12952C11.3583 8.82802 10.8708 8.96602 10.5708 9.26752C10.2693 9.56752 10.2693 10.055 10.5708 10.3565L12.3723 12.02L2.30282 12.0215C1.86332 12.0215 1.50632 12.3215 1.50782 12.746C1.50632 13.1705 1.86332 13.442 2.30432 13.442H12.3738L10.5723 15.3065C10.2708 15.608 10.2708 16.094 10.5723 16.397C10.7223 16.547 10.9173 16.4855 11.1153 16.4855C11.3133 16.4855 11.5098 16.4075 11.6583 16.259Z"
                            fill="#DC3545"
                          />
                        </svg>
                      ) : (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M19.704 6H18.837C16.9005 6 16.9035 3 15.5355 3H7.2945C5.7525 3 4.5 4.2525 4.5 5.796V9H6V5.796C6 5.082 6.582 4.5 7.2945 4.5H15.2505C15.3435 4.644 15.462 4.86 15.5475 5.0205C16.05 5.9475 16.8915 7.5 18.837 7.5H19.704C20.37 7.5 21 8.229 21 9V18.2055C21 18.918 20.418 19.5 19.704 19.5H7.2945C6.582 19.5 6 18.918 6 18.2055V16.5H4.5V18.2055C4.5 19.749 5.7525 21 7.2945 21H19.7025C21.2475 21 22.5 19.749 22.5 18.2055V9C22.5 7.4565 21.2475 6 19.704 6Z"
                            fill="#15B392"
                          />
                          <path
                            d="M11.6583 16.259L14.7768 13.2155C14.7798 13.2125 14.7813 13.208 14.7843 13.2035C14.8503 13.1375 14.9058 12.98 14.9433 12.893C14.9748 12.812 14.9868 12.878 14.9928 12.797C14.9928 12.779 15.0018 12.764 15.0018 12.7475C15.0018 12.7355 14.9958 12.7265 14.9958 12.716C14.9913 12.626 14.9748 12.581 14.9433 12.497C14.9118 12.4205 14.8608 12.356 14.8083 12.2945C14.7963 12.2795 14.7903 12.2585 14.7768 12.245L11.6583 9.12952C11.3583 8.82802 10.8708 8.96602 10.5708 9.26752C10.2693 9.56752 10.2693 10.055 10.5708 10.3565L12.3723 12.02L2.30282 12.0215C1.86332 12.0215 1.50632 12.3215 1.50782 12.746C1.50632 13.1705 1.86332 13.442 2.30432 13.442H12.3738L10.5723 15.3065C10.2708 15.608 10.2708 16.094 10.5723 16.397C10.7223 16.547 10.9173 16.4855 11.1153 16.4855C11.3133 16.4855 11.5098 16.4075 11.6583 16.259Z"
                            fill="#15B392"
                          />
                        </svg>
                      )}
                    </span>
                    <span>
                      Are you sure want to{" "}
                      {isDelete.isActive ? "Deactivate" : "Activate"}{" "}
                      <b>{isDelete.trialName}</b>?
                    </span>
                  </div>
                </div>

                <div className="flex flex-row justify-end gap-5 mt-5">
                  <button
                    className={`px-5 py-1 text-base rounded-md border primary_btn transition-all duration-500  ${
                      isDelete.isActive ? "red_btn" : "green_btn"
                    }`}
                    onClick={() => {
                      inactiveTrials(isDelete);
                    }}
                  >
                    {isDelete.isActive ? "Move" : "Move"}
                  </button>
                  <SecondaryButton
                    onClick={() => {
                      setIsDelete(false);
                    }}
                    label="Cancel"
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Trials;
